import { ComponentType } from '@angular/cdk/overlay';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  OnInit,
  ViewChild,
} from '@angular/core';
import { AppState } from '@app/core/states/app.state';
import { LibraryAllComponent } from '@app/library/components/content/library-all/library-all.component';
import { LibraryMobileComponent } from '@app/library/components/content/library-mobile/library-mobile.component';
import { LibraryHostDirective } from '@app/library/directives/library-host.directive';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'rk-library-host',
  templateUrl: './library-host.component.html',
  styleUrls: ['./library-host.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LibraryHostComponent implements OnInit {
  @ViewChild(LibraryHostDirective, { static: true }) libHost: LibraryHostDirective;
  @Select(AppState.onMobile)
  onMobile$: Observable<boolean>;

  @Select(AppState.onTablet)
  onTablet$: Observable<boolean>;

  constructor(
    private readonly componentFactoryResolver: ComponentFactoryResolver,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.onMobile$.subscribe(mob => {
      if (mob) {
        this.loadComponent(LibraryMobileComponent);
      } else {
        this.loadComponent(LibraryAllComponent);
      }
    });
  }

  loadComponent(comp: ComponentType<any>) {
    const viewContainerRef = this.libHost.viewContainerRef;
    viewContainerRef.clear();
    const dynamicComponentFactory =
      this.componentFactoryResolver.resolveComponentFactory(comp);

    viewContainerRef.createComponent<any>(dynamicComponentFactory);
    // Force change to trigger ngOnInit() on components
    this.cdr.detectChanges();
  }
}
